module.exports = __webpack_public_path__ + "media/media/social/facebook-logo-8520c2b0648bbf2647e0570b7d59eef5.png";